export default "__VITE_ASSET__GxyPDET7__"